module.exports = __webpack_public_path__ + "img/purple-marker.d873dd18.svg";